// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
var captureMessage$prime = function (msg) {
    return $foreign.captureMessage(msg)({});
};
export {
    captureMessage
} from "./foreign.js";
export {
    captureMessage$prime
};
//# sourceMappingURL=index.js.map
